import { FC } from 'react';
import type { AmwayHighlightsItemProps, AmwayHighlightsProps } from './types/propTypes';
import AmwayHighlightsItem from './AmwayHighlightsItem';
import styles from './AmwayHighlights.module.scss';

const AmwayHighlights: FC<AmwayHighlightsProps> = ({ amwayHighlightsData }) => (
  <div className={styles['amway-highlights-container']} data-testid={'amway-highlights-test-id'}>
    {amwayHighlightsData.map((item: AmwayHighlightsItemProps) => (
      <AmwayHighlightsItem
        key={`${item.title}${item.description}`}
        images={item.images}
        description={item.description}
        title={item.title}
      />
    ))}
  </div>
);

export default AmwayHighlights;
export type { AmwayHighlightsProps };
